<template>
  <div class="date-picker__container">
    <div class="date-picker has-text-centered">
      <div class="columns is-mobile">
        <div class="column is-2 u-p-b-0">
          <BIcon
            class="date-selection__icon"
            icon="chevron-left"
            @click.native="handleGoToPreviousDate"
          />
        </div>
        <div class="column u-p-b-0">
          <span class="is-size-5 is-size-6-mobile">{{ activeDate.toLocaleString('en-US', dateOptions) }}</span>
          <p v-if="!doesActiveDateHaveStandup" class="has-text-danger is-size-7">(No Standup Today)</p>
          <p v-else class="is-size-7">&nbsp;</p> <!-- Empty line to prevent other elements from jumping -->
        </div>
        <div class="column is-2 u-p-b-0">
          <BIcon class="date-selection__icon" icon="chevron-right" @click.native="handleGoToNextDate"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { defaultDateOptions } from '@/helpers/dateHelpers';
import { daysOfTheWeek } from '@/constants/TimeAndDateConstants';
import { isArrayEmpty } from '@/helpers/dataHelpers';

export default {
  name: 'DatePicker',

  props: {
    activeTeamIds: {
      type: Array,
      required: true,
    },
    activeDate: {
      type: Date,
      required: false,
      default: () => new Date(),
    },
  },

  data() {
    return {
      dateOptions: defaultDateOptions,
    };
  },

  computed: {
    ...mapState({
      teams: state => state.team.teams,
    }),
    activeTeams() {
      if (isArrayEmpty(this.activeTeamIds)) return [];

      return this.activeTeamIds.map(teamId => this.teams[teamId]);
    },
    doesActiveDateHaveStandup() {
      if (isArrayEmpty(this.activeTeams) && !this.isLoading) return false;

      const activeDateWeekDayIndex = this.activeDate.getDay();
      const meetingDays = [...new Set(
        this.activeTeams
          .map(team => team.standupMeetingDayIds)
          .flat()
          .map(dayId => daysOfTheWeek.find(day => day.id === dayId)),
      )];

      return meetingDays.find(day => day.weekDayIndex === activeDateWeekDayIndex);
    },
  },

  methods: {
    handleGoToPreviousDate() {
      const newDate = new Date(this.activeDate.setDate(this.activeDate.getDate() - 1));
      this.$emit('activeDateChanged', newDate);
    },
    handleGoToNextDate() {
      const newDate = new Date(this.activeDate.setDate(this.activeDate.getDate() + 1));
      this.$emit('activeDateChanged', newDate);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-picker__container {
  width: 100%;
  margin-bottom: 0rem;
  margin-top: 1rem;
}

.date-picker {
  max-width: 480px;
  margin: 0 auto;
}

.date-selection__icon {
  cursor: pointer;
  vertical-align: middle;

  :hover {
    transform: scale(1.4);
    transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
}
</style>
